// Author: Ayesha Shaikh
// Date : 03 april 2025
import React, { useEffect, useState } from "react";
import { Chip, Grid } from "@mui/material";
import HeadingCard from "../../../newComponent/NewCardsComp/HeadingCard";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../../../utils/token";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import MainCard from "../../../../components/Maincard";
import FilterButtonComponent from "../../../newComponent/NewButtonComp/FilterButtonComponent";
import MiscellaneousPaymentFilter from "./MiscellaneousPaymentFilter";
import VeiwIcon from "../../../newComponent/iconsComp/VeiwIcon";
import SearchTextFieldComp from "../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import DenyIcon from "../../../newComponent/iconsComp/DenyIcon";
import CustomPopup from "../../../../components/CustomPopup";
import CancelPayment from "./CancelPayment";
import { useDateUtils } from "../../../../utils/formatTime";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const PATH_URL = process.env.REACT_APP_API_UPLOADS;
export default function AllMiscellaneousPayment() {
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
  const userRole=localStorage.getItem('userRole')

  const userId = localStorage.getItem("userId");
  const [isLoading, setIsLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [openFilter, setOpenFilter] = useState(false);
  const [opencancel, setOpenCancel] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpenCancelPopup = (rowId) => {
    setOpenCancel(true);
    setSelectedRowId(rowId);
  };

  const handleCloseCanclePopup = () => {
    setOpenCancel(false);
  };

  // Filter Toggle
  const handleToggleFilter = () => {
    setOpenFilter(!openFilter);
  };

  //   Fetch AllMiscellaneous Payment Data
  useEffect(() => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${API_ENDPOINT}miscellaneousfees/fetchmiscellaneousfeebyuserId/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();

          const sortedData = data.sort(
            (a, b) => new Date(b.payment_date) - new Date(a.payment_date)
          );

          setPayments(sortedData);
          setOriginalData(sortedData);
          setSearchData(sortedData);
          setIsLoading(false);
        } else if (response.status === 404) {
          showSnackbar("Couldn't find any miscellaneous payments", "error");
          setIsLoading(false);
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, [userId]);

  // View deposite Slip
  const handleViewDepositSlip = (filePath) => {
    window.open(`${PATH_URL}miscellaneousReceiptUploads/${filePath}`, "_blank");
  };

  // Cancel Payment
  const handleCancelPayment = async () => {
    // Handle form submission logic here

    const requestData = {
      user_id: parseInt(userId),
      miscellaneous_fee_id: selectedRowId,
      approval_status: "cancelled",
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}miscellaneousfees/updateapprovalstatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Make sure to keep the content type
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        showSnackbar("Data Updated Successfully", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar("Please pass a valid approval status", "error");
      } else if (response.status === 401) {
        showSnackbar("Unauthorized User", "error");
      } else if (response.status === 405) {
        showSnackbar("Miscellaneous fee ID cannot be null", "error");
      } else if (response.status === 404) {
        showSnackbar("No active miscellaneous payment with this id", "error");
      } else if (response.status === 500) {
        showSnackbar("Server Error", "error");
      } else {
        showSnackbar("Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      headerAlign: "center",
      align: "center",
      // valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <VeiwIcon
            tooltipTitle="View"
            onClick={() =>
              handleViewDepositSlip(
                params?.row?.miscellaneous_receipt_id?.file_uploaded
              )
            }
            fontSize="1rem"
          />
          {params?.row?.approval_status === "pending" && (
            <DenyIcon
              tooltipTitle="Cancel"
              fontSize="1rem"
              onClick={() => handleOpenCancelPopup(params?.row?.id)}
            />
          )}
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row.enquiry_id.id}`,
              "_blank"
            )
          }
        >
          {" "}
          {`${
            params?.row?.enquiry_id?.first_name
              ? params?.row?.enquiry_id?.first_name
              : ""
          } ${
            params?.row?.enquiry_id?.last_name
              ? params?.row?.enquiry_id?.last_name
              : ""
          }`}{" "}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.mobile_country_code}
      {userRole === "advisor" || userRole === "trainer"
        ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
        : params.row?.enquiry_id?.mobile}</div>,
    },
    {
      field: "pte_id",
      headerName: "PTE Id",
      width: 100,
      headerClassName: "header-cell",
    },
    {
      field: "test_type_id",
      headerName: "Test Type",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.test_type_id?.name || "",
      renderCell: (params) => <div>{params?.row.test_type_id?.name}</div>,
    },
        {
      field: "currency",
      headerName: "currency",
      flex: 0.7,
      headerClassName: "header-cell",
    
    },

    {
      field: "test_fees",
      headerName: "Test Fees",
      width: 100,
      headerClassName: "header-cell",
    },
    {
      field: "paid_amount",
      headerName: "Paid Amount",
      width: 100,
      headerClassName: "header-cell",
    },
    {
      field: "voucher_amount",
      headerName: "Voucher Amount",
      width: 100,
      headerClassName: "header-cell",
    },
    {
      field: "revenue_amount",
      headerName: "Revenue Generated",
      width: 100,
      headerClassName: "header-cell",
    },
  
    {
      field: "approval_status",
      headerName: "Status",
      width: 100,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row.approval_status === "pending" ? (
            <Chip
              color="warning"
              size="normal"
              label="Pending"
              variant="contained"
            />
          ) : params?.row.approval_status === "denied" ? (
            <Chip
              color="error"
              size="normal"
              label="Denied"
              variant="contained"
            />
          ) : params?.row.approval_status === "cancelled" ? (
            <Chip
              color="primary"
              size="normal"
              label="Cancelled"
              variant="contained"
            />
          ) : (
            <Chip
              color="secondary"
              size="normal"
              label="Approved"
              variant="contained"
            />
          )}
        </div>
      ),
    },

    {
      field: "collected_by",
      headerName: "Collected By",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.collected_by?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row.collected_by?.first_name}{" "}
          {params?.row.collected_by?.last_name}
        </div>
      ),
    },
    {
      field: "branch_collected_by",
      headerName: "Branch Collected By",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params?.row.branch_collected_by?.branch_name || "",
      renderCell: (params) => (
        <div>{params?.row.branch_collected_by?.branch_name} </div>
      ),
    },

    {
      field: "created_date",
      headerName: "Collected Date",
      width: 100,
      headerClassName: "header-cell",
    },
    {
      field: "approve_deneid_by",
      headerName: "Approved/Denied By",
      width: 150,
      valueGetter: (params) => params?.row.approved_by?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row.approved_by?.first_name}{" "}
          {params?.row.approved_by?.last_name}{" "}
          {params?.row.denied_by?.first_name} {params?.row.denied_by?.last_name}
        </div>
      ),
    },
    {
      field: "approve_denied_date",
      headerName: "Approved/Denied Date",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params?.row.denied_date || params?.row.approved_date || "",
      renderCell: (params) => (
        <div>
          {params?.row.approved_date} {params?.row.denied_date}
        </div>
      ),
    },

    {
      field: "denied_remarks",
      headerName: "Denied Remark",
      width: 100,
      headerClassName: "header-cell",
    },
  ];

  // Search All column data

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.enquiry_id?.first_name || ""} ${
          data?.enquiry_id?.last_name || ""
        }`,

        `${data?.enquiry_id?.mobile || ""}`,

        `${data?.branch_collected_by?.branch_name || ""}`,

        `${data?.pte_id || ""}`,
        `${data?.test_type_id?.name || ""}`,
        `${data?.pending_amount}`,

        `${data?.created_date}`,
        `${data?.collected_by?.first_name || ""} ${
          data?.collected_by?.last_name || ""
        }`,
        `${data?.test_fees || " "}`,
        `${data?.paid_amount || " "}`,
        `${data?.voucher_amount || " "}`,

        `${data?.revenue_amount || " "}`,

        `${data?.approval_status || " "}`,

        `${data?.approved_by?.first_name || ""} ${
          data?.approved_by?.last_name || ""
        }`,
        `${data?.denied_by?.first_name || ""} ${
          data?.denied_by?.last_name || ""
        }`,

        `${data?.denied_date || " "}`,

        `${data?.denied_remarks || " "}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setPayments(filteredData1); // Update the filtered data
  };
  return (
    <>
      <LoaderComp isLoading={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} md={4} lg={3}>
          {/* Heading */}
          <HeadingCard label="Miscellaneous Payment" />{" "}
        </Grid>
        {/* Filter  */}
        <Grid item xs={12} sm={7} md={8} lg={9} textAlign="end">
          <FilterButtonComponent
            showendIcon={true}
            open={openFilter}
            onClick={handleToggleFilter}
            sx={{ mr: 2 }}
          />
        </Grid>

        {/* Filter Comp */}

        <Grid item xs={12}>
          <MiscellaneousPaymentFilter
            open={openFilter}
            setSearchData={setSearchData}
            setPayments={setPayments}
            setOriginalData={setOriginalData}
            setIsLoading={setIsLoading}
            showSnackbar={showSnackbar}
            originalData={originalData}
          />
        </Grid>

        {/* Datagrid */}
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="end">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={payments}
                  columns={columns}
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  autoHeight
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={opencancel}
        onClose={handleCloseCanclePopup}
        component={
          <CancelPayment
            handleCancelPayment={handleCancelPayment}
            onClose={handleCloseCanclePopup}
          />
        }
        showDivider={true}
        title="Confirmation"
        maxWidth="xs"
      />
    </>
  );
}
